import { render, staticRenderFns } from "./TaoDonVi.vue?vue&type=template&id=5dfaa0db&"
import script from "./TaoDonVi.vue?vue&type=script&lang=js&"
export * from "./TaoDonVi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports